import { render } from "./Navbar.vue?vue&type=template&id=839379dc&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./navbar.scss?vue&type=style&index=0&id=839379dc&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-839379dc"]])

export default __exports__